import { cn } from '@workspace/ui/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'

const textInputVariants = cva(
  'flex w-full rounded-md border bg-transparent transition-all file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-60 outline-none focus-visible:border-[rgb(249,115,22)] focus-visible:ring-[rgb(249,115,22)]/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive [&::-webkit-calendar-picker-indicator]:opacity-50 [&::-webkit-calendar-picker-indicator]:invert',
  {
    variants: {
      variant: {
        default:
          'border-border bg-input text-foreground placeholder:text-muted-foreground shadow-xs',
        ghost: 'border-transparent shadow-none',
      },
      inputSize: {
        sm: 'h-8 text-xs px-3 py-1.5',
        md: 'h-10 text-sm px-3 py-2',
        lg: 'h-14 text-lg px-3 py-4',
      },
    },
    defaultVariants: {
      variant: 'default',
      inputSize: 'md',
    },
  }
)

function TextInput({
  className,
  variant,
  inputSize,
  type = 'text',
  ...props
}: React.ComponentProps<'input'> & VariantProps<typeof textInputVariants>) {
  return (
    <input
      type={type}
      data-slot="text-input"
      className={cn(textInputVariants({ variant, inputSize, className }))}
      {...props}
    />
  )
}

export { TextInput, textInputVariants }
